import { TwilioBusinessProfile, TwilioRegulatoryBundleRule, jsonSafeToTwilioBusinessProfile, jsonSafeToTwilioRegulatoryBundleRule } from "./db";


export enum PaymentSubscriptionOption {
  STANDARD = 'STANDARD',
  PARALLEL = 'PARALLEL'
}

export const PaymentSubscriptionOptionToPaymentLink: {
  [k in PaymentSubscriptionOption]: string
} = {
  [PaymentSubscriptionOption.STANDARD]: 'https://buy.stripe.com/6oE6oF7Oqf0Laju5nK',
  [PaymentSubscriptionOption.PARALLEL]: 'https://buy.stripe.com/5kA00h0lY5qb3V67vT',
}

export const SubscriptionTypeToHumanReadable: {
  [k in PaymentSubscriptionOption]: string
} = {
  [PaymentSubscriptionOption.STANDARD]: 'Standard',
  [PaymentSubscriptionOption.PARALLEL]: 'Parallel Dialer'
}

export const SubscriptionTypeToPriceInfo: {
  [k in PaymentSubscriptionOption]: string
} = {
  [PaymentSubscriptionOption.STANDARD]: '59.99',
  [PaymentSubscriptionOption.PARALLEL]: '149.99'
}

export type ParallelDialerAccessInfo = {
  profiles: TwilioBusinessProfile[]
  bundle_rules: TwilioRegulatoryBundleRule[]
  weekly_cost: Record<string, number>
  number_count: Record<string, number>
}

export function jsonSafeToParallelDialerAccessInfo(v: Record<string, any>): ParallelDialerAccessInfo {
  return {
    profiles: v.profiles.map(jsonSafeToTwilioBusinessProfile),
    bundle_rules: v.bundle_rules.map(jsonSafeToTwilioRegulatoryBundleRule),
    weekly_cost: v.weekly_cost,
    number_count: v.number_count,
  }
}
